import Fetch from 'jsx/common/util/_fetch';

export const revokeall = async (message = '') => {
  return Fetch.post(`/api/remote-session/revokeall/`, {
    body: JSON.stringify({ message }),
  });
};

export const revoke = async (id: string, message = '') => {
  return Fetch.put(`/api/remote-session/${id}/revoke/`, {
    body: JSON.stringify({ message }),
  });
};

export const start = async (params: any) => {
  return Fetch.post(`/api/remote-session/start/`, {
    body: JSON.stringify(params),
  });
};

export const startRecordingExport = async (params: any) => {
  return Fetch.post(`/api/remote-recording-export/`, {
    body: JSON.stringify(params),
  });
};

export default {
  revoke,
  revokeall,
  start,
  startRecordingExport,
};
